import Layout from 'components/layout';
import { SetRoutes } from 'components';
import routes from './routes';

const DocumentsPage = () => {
  return (
    <Layout>
      <SetRoutes routes={routes} />
    </Layout>
  );
};

export default DocumentsPage;
